var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { Button, Input } from "semantic-ui-react";
import FieldWithErrorDisplay from "../FieldWithErrorDisplay";
var AddReferralModal = /** @class */ (function (_super) {
    __extends(AddReferralModal, _super);
    function AddReferralModal(props) {
        var _this = _super.call(this, props) || this;
        _this.onReferralNoteChange = function (event, data) {
            var val = data.value;
            _this.setState({
                referralNote: val
            });
        };
        _this.submit = function () {
            _this.props.postRequest('/admin/add-marketing-referral', {
                referralNote: _this.state.referralNote
            });
        };
        _this.state = {
            referralNote: ''
        };
        return _this;
    }
    AddReferralModal.prototype.render = function () {
        return React.createElement(React.Fragment, null,
            React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/referralNote', required: true, labelContent: 'Referral Note' },
                React.createElement(Input, { onChange: this.onReferralNoteChange })),
            React.createElement(Button, { disabled: this.state.referralNote.trim() === "", icon: 'plus', label: 'Generate Referral Link', labelPosition: 'left', onClick: this.submit, positive: true }));
    };
    return AddReferralModal;
}(React.PureComponent));
export default AddReferralModal;
//# sourceMappingURL=AddReferralModal.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/admin/AddReferralModal.js
// module id = 1468
// module chunks = 0